import { SliceCardsCollectionCardView } from '@utmb/types/index';
import { ReactElement } from 'react';
import { Image } from '@utmb/design-system/image/Image';
import styles from './card-title-over-picture.module.scss';
import { Font } from '@utmb/design-system/text/font';
import { getColorStyle } from '@utmb/utils/colors';
import { useGlobal } from '@utmb/contexts/GlobalContext';
import { parseMarkdown } from '@utmb/utils/markdown';
import { LinkTypeEnum } from '@utmb/types/enum/LinkTypeEnum';
import { ButtonRemake } from '@utmb/design-system/button-remake/ButtonRemake';
import { Link } from '@utmb/design-system/link/link';
import { ColorTypesEnum } from '@utmb/types/colors';
export const CardTitleOverPicture = (props: SliceCardsCollectionCardView): ReactElement => {
    const { title, summary, link, picture, color } = props;

    const {
        global: {
            event: { primaryColorIsDark },
        },
    } = useGlobal();
    return (
        <div className={styles.cardTitleOverPicture}>
            <div className={styles.header} style={{ background: color ? getColorStyle(color) : 'unset' }}>
                <Font.FuturaHeavy className={styles.title} color={getColorStyle(ColorTypesEnum.WHITE)}>
                    {title}
                </Font.FuturaHeavy>
                <div className={styles.background}>
                    {picture ? <Image className={styles.picture} layout="fill" objectFit="cover" image={picture} maxWidth={500} /> : null}
                </div>
            </div>
            <div className={styles.content}>
                {summary && (
                    <Font.FuturaBook className={styles.summary} mobile="14" as="div">
                        <div
                            className={`markdown ${primaryColorIsDark ? 'primaryColorIsDark' : ''}`}
                            dangerouslySetInnerHTML={{ __html: parseMarkdown(summary) }}
                        />
                    </Font.FuturaBook>
                )}
                {link && (
                    <>
                        {link.type === LinkTypeEnum.BUTTON ? (
                            <div className={styles.wrapButton}>
                                <ButtonRemake customClassName={styles.button} action={link.slug} label={link.label} variant="solid" target={'_self'} />
                            </div>
                        ) : (
                            <Font.FuturaBook mobile="14" className={styles.content_link}>
                                <Link className="font-underline -stretched-link" href={link.slug} followClassName={`${link.followClass}-ga`}>
                                    {link.label}
                                </Link>
                            </Font.FuturaBook>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};
